var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_3060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2786 2.13563C19.6691 1.74511 19.6691 1.11195 19.2786 0.721421C18.8881 0.330897 18.2549 0.330897 17.8644 0.721421L10 8.58576L2.1357 0.721421C1.74517 0.330897 1.11201 0.330897 0.721482 0.721421C0.330958 1.11195 0.330958 1.74511 0.721482 2.13563L8.58582 9.99997L0.721482 17.8643C0.330958 18.2548 0.330958 18.888 0.721482 19.2785C1.11201 19.669 1.74517 19.669 2.1357 19.2785L10 11.4142L17.8644 19.2785C18.2549 19.669 18.8881 19.669 19.2786 19.2785C19.6691 18.888 19.6691 18.2548 19.2786 17.8643L11.4142 9.99997L19.2786 2.13563Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_3060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.978b4703d363c158591d7fd5c70e1edd.svg";
export { ForwardRef as ReactComponent };